// Vista para revisar si las invitaciones se pudieron enviar 

// Imports 
import React from 'react';
import {Col, Row, Typography, List, Divider, Breadcrumb} from "antd";
import axios from 'axios';
import {Card, Avatar} from 'antd';

import {Result} from 'antd';
import {CalendarOutlined, CheckCircleTwoTone, UserOutlined, CloseCircleTwoTone} from '@ant-design/icons';
import 'antd/dist/antd.css';
import {   
    getSponsors,
} from "./VisitConsumer";



const {Paragraph, Text} = Typography;


//Componente Invitaciones enviadas 
class InvitacionesEnviadas extends React.Component {
    state = JSON.parse(localStorage.getItem('sent_info'));


    //Saco los sponsor para  mostrarlos (No se usa ahora porque pueden haber muchos sponsors. )
    componentDidMount() {
        const API_URL = window.ENV.API_URL;
        const headers = {
            headers: {
                Authorization: window.Token
            }
        };

        getSponsors([this.state.sponsor]).then(res => {
            this.setState({
                sponsor : res.data[0].nombres + " " + res.data[0].paterno + " " + res.data[0].materno
           });
           return this.state.sponsor
            
        });
    }

    render() {

        //Constantes para mostrar en fecha inicio - termino 
        const fechas = [
            {
                title: 'Inicio',
                fecha: this.state.inicio_visita,
            },
            {
                title: 'Término',
                fecha:  this.state.termino_visita,
            },
        ];

        const Patrocinador = [
            {
                title: 'Patrocinador',
                name: this.state.sponsor
            },
        ];

        //Separamos cuales se enviaron y cuales no para darles despues rojo en el caso que no funcionaron 
        const mails = JSON.parse(localStorage.getItem('mails'))
        /* var enviados = []
        if (mails.mails_enviados){
            enviados = mails.mails_enviados.filter(mail => !mails.mails_rechazados.includes(mail))
        } */
        const enviados = mails.mails_enviados
        const no_enviados = mails.mails_rechazados
        return (
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <a href="/main">Menú principal</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item><a href="/sendinvitations">Enviar invitaciones</a></Breadcrumb.Item>
                    <Breadcrumb.Item>Envío</Breadcrumb.Item>
                </Breadcrumb>

                <Card>


                    <Result
                        status={no_enviados ? "warning" : "success"}
                        title={no_enviados ? "Existen problemas con el envío de solicitudes" : "Envío de solicitudes exitoso"}
                    >

                        <div className="desc">
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                    {enviados ?
                                        <List
                                            size="small"
                                            header={<Text strong>
                                                    Se enviaron solicitudes a los siguientes correos
                                                </Text>}
                                            dataSource={enviados}
                                            renderItem={item =>
                                                <Paragraph>
                                                    <CheckCircleTwoTone twoToneColor="#52c41a"/> {item}
                                                </Paragraph>
                                            }
                                        />
                                        : ""}
                                    {no_enviados ?
                                        <List
                                            size="small"
                                            header={<Text strong>
                                                    Estas solicitudes no pudieron ser enviadas, por favor revíselas.
                                                </Text>}
                                            dataSource={no_enviados}
                                            renderItem={item =>
                                                <Paragraph>
                                                    <CloseCircleTwoTone twoToneColor="#FF2424"/> {item}
                                                </Paragraph>}
                                        />
                                        : " "}
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                    <Text strong>
                                        Detalles de las solicitudes
                                    </Text>
                                    <Divider/>

                                    <List
                                        itemLayout="horizontal"
                                        dataSource={fechas}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={<Avatar shape="square" size="large"
                                                                    icon={<CalendarOutlined/>}/>}
                                                    title={item.title}
                                                    description={item.fecha}
                                                />
                                            </List.Item>
                                        )}
                                    />

                                    <List
                                        itemLayout="horizontal"
                                        dataSource={Patrocinador}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={<Avatar shape="square" size="large"
                                                                    icon={<UserOutlined/>}/>}
                                                    title={item.title}
                                                    description={item.name}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
                            <Divider/>
                            <Paragraph>
                                <Text strong>
                                    Puedes verlas en <a href="invites">Invitaciones pendientes</a>
                                </Text>
                            </Paragraph>
                        </div>
                    </Result>
                </Card>
            </div>
        );
    }
}

export default InvitacionesEnviadas;